<!-- eslint-disable -->
<template lang="pug">
    .presentation-theme(:class="{'presentation-theme--disable': !profile.presentations.length}")
        .row.presentation-preview
            .col-xs-10.col-sm-11.presentation-preview__column
                .presentation-preview__item(@click="openTheme")
                    .presentation-preview__avatar
                        svg-icon.presentation-preview__icon(name="tablet", size="x-large")
                    .preview__text.preview__text_large.presentation-preview__name
                        span {{ profile.name }}
                        svg-icon.presentation-theme__icon(
                            v-show='profile.id === openedThemeId',
                            name="angle", width="14px", height="9px"
                        )
            .col-xs-2.col-sm-1.last-sm.end-xs.presentation-preview__column(v-if="canEditPresentationTheme")
                dropdown(:icon="false" :is-last="isLast" without-move)
                    template(slot="link")
                        svg-icon.presentation-preview__icon.presentation-preview__icon_blue(
                            name="select", :size="selectorSize"
                        )
                    ul.dropdown__links
                        li.dropdown__link
                            router-link.school-preview__link(
                                :to="{\
                                    name: profile.isEducationMaterial\
                                            ? 'education-materials-theme:edit'\
                                            : 'presentations-theme:edit',\
                                    params: {\
                                            id: profile.id,\
                                            copy: profile,\
                                            openedThemeId: openedThemeId\
                                    }\
                                }"
                            )
                                | {{ $i18n.t('list.list_common_actionsEdit') }}
                        li.dropdown__link(v-if="profile.id !== 1 && ((user.isSuperadmin || user.isManagerOrSupport) || !profile.isEducationMaterial)")
                            a(
                                href="javascript://"
                                @click="displayConfirmDeleteModal = true"
                            )
                                | {{ $i18n.t('list.list_common_actionsDelete') }}
                confirm-delete-modal(
                    v-if="displayConfirmDeleteModal"
                    @close="displayConfirmDeleteModal = false"
                    @delete="$emit('delete', profile.id)"
                )
                    | {{ " " + $i18n.t('list.list_presentation_deletePresentationTheme') }} "{{ profile.name }}"
        transition-expand(v-show='profile.id === openedThemeId')
            .presentation-preview.presentation-preview--indent
                .row.presentation.presentation-preview.presentation-element(
                    v-for='presentation in profile.presentations',
                    :class="{'presentation--selected': selectedPresentationId === presentation.id}",
                    @dblclick='startPresentation(presentation)'
                    :key='presentation.id'
                )
                    .col-xs-10.col-sm-11.presentation-preview__column
                        .presentation-preview__item(@click='selectPresentation(presentation)')
                            .presentation-preview__avatar
                                svg-icon.presentation-preview__icon(name="tablet", size="x-large")
                            .preview__text.preview__text_large.presentation-preview__name
                                span {{ presentation.name }}
                    .col-xs-2.col-sm-1.last-sm.end-xs.presentation-preview__column(v-if='canEditPresentation(presentation)')
                        dropdown(:icon="false" :is-last="isLast" without-move)
                            template(slot="link")
                                svg-icon.presentation-preview__icon.presentation-preview__icon_blue(name="select", :size="selectorSize")
                            ul.dropdown__links
                                li.dropdown__link
                                    router-link.school-preview__link(
                                        :to="{\
                                            name: presentation.isEducationMaterial\
                                                ? 'education-material:edit'\
                                                : 'presentation:edit',\
                                            params: {\
                                                id: presentation.id,\
                                                copy: presentation,\
                                                openedThemeId: openedThemeId\
                                            }\
                                        }"
                                    )
                                        | {{ $i18n.t('list.list_common_actionsEdit') }}
                                li.dropdown__link(v-if='(user.isSuperadmin || user.isManagerOrSupport) || !presentation.isEducationMaterial')
                                    a(
                                        href='javascript://',
                                        @click='displayConfirmDeletePresentationModal[presentation.id] = true'
                                    )
                                        | {{ $i18n.t('list.list_common_actionsDelete') }}
        confirm-delete-modal(
            v-for="presentation in profile.presentations"
            :key="'presentationModalDelete' + presentation.id"
            v-if="displayConfirmDeletePresentationModal[presentation.id]"
            @close="displayConfirmDeletePresentationModal[presentation.id] = false"
            @delete="$emit('deletePresentation', presentation.id)"
        )
            | {{ " " + $i18n.t('list.list_presentation_deletePresentation') }} "{{ presentation.name }}"
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../elements/Dropdown.vue';
    const ConfirmDeleteModal = () => import('../../../modals/ConfirmDeleteModal.vue');
    import TransitionExpand from '../../../elements/TransitionExpand.vue';
    import { mapState } from 'vuex';

    export default {
        props: {
            profile: {
                type: Object,
                default: null,
            },
            isLast: Boolean,
            selectedPresentationId: {
                type: [String, Number],
            },
            openedThemeId: {
                type: [String, Number],
            }
        },
        mounted () {
            if (this.profile && this.profile.presentations) {
                let presentationsIds = this.profile.presentations.map(presentation => presentation.id);
                let objectWithIdsAsKeys = {};
                presentationsIds.forEach(id => objectWithIdsAsKeys[id] = false);
                this.displayConfirmDeletePresentationModal = objectWithIdsAsKeys;
            }
        },
        data() {
            return {
                displayConfirmDeleteModal: false,
                displayConfirmDeletePresentationModal: {},
                isInAlphabeticalOrder: false,
            };
        },
        methods: {
            selectPresentation (presentation) {
                this.$emit('selectPresentation', presentation);
            },
            startPresentation (presentation) {
                this.$emit('startPresentation', presentation);
            },
            openTheme () {
                this.$emit('open', this.profile.id);
            },
            changeAlphabeticalOrder () {
                this.isInAlphabeticalOrder = !this.isInAlphabeticalOrder;
                this.profile.presentations = this.profile.presentations.reverse();
            },
            canEditPresentation (presentation) {
                if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                    return true;
                }
                if (presentation.isEducationMaterial && this.user.type === 'admin' ) {
                    return presentation.usersFilterType === null
                            || !!_.intersectionBy(this.user.schools, presentation.schools, 'id').length;
                }
                return this.user.id === presentation.userId
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            canEditPresentationTheme () {
                if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                    return true;
                }
                if (this.profile.isEducationMaterial && this.user.type === 'admin') {
                    return this.profile.usersFilterType === null
                            || !!_.intersectionBy(this.user.schools, this.profile.schools, 'id').length;
                }
                return this.user.id === this.profile.userId
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            }
        },
        components: {
            Dropdown,
            ConfirmDeleteModal,
            TransitionExpand,
        }
    }
</script>

<style lang="scss" scoped>
    .presentation-preview {
        margin: 8px 0;
        padding: 16px;
    }

    .presentation-preview--indent {
        margin: 0 0 24px 0;
        padding: 0 16px;
    }

    .presentation-theme {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        cursor: pointer;
        &:hover {
            background-color: #fbfbfb;
            border-color: #BDBDBD;
        }
    }

    .presentation-theme:first-child {
        margin-top: 0;
    }

    .presentation-theme:last-child {
        margin-bottom: 0;
    }

    .presentation-theme--disable {
        cursor: auto;
        border: 1px solid $hsl-color-red-62;
        &:hover {
            background-color: $x-color-white;
            border: 1px solid $hsl-color-red-62;
        }
    }

    .presentation-theme__icon {
        margin-left: 8px;
    }

    .presentation {
        cursor: pointer;
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        &:hover {
            background-color:  $hsl-color-gray-98;
            border-color: $hsl-color-gray-74;
        }
    }

    .presentation--selected {
        background: $hsl-color-blue-56;

        &:hover {
            background-color: $hsl-color-blue-56;
            border-color: $hsl-color-gray-74;
        }

        & .presentation-preview__icon_blue {
            color: $x-color-white;
        }

        & .presentation-preview__name {
            color: $x-color-white;
        }
    }

    .presentation-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin: 0;
    }

    .presentation-preview__column_hide-name {
        @include media($sm) {
            display: none;
        }
    }

    .presentation-preview__name {
        display: flex;
        align-items: center;
    }

    .presentation-preview__icon {
        color: $hsl-color-green-58;
    }

    .presentation-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .presentation-preview__avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        max-height: none;
        height: 50px;
        width: 50px;
        min-width: 50px;
        background-color: #F3F8EF;
    }

    .presentation-preview__items {
        display: flex;
        margin: -4px 0;
    }

    .presentation-preview__items_columned {
        flex-direction: column;
    }

    .presentation-preview__item {
        display: flex;
        align-items: center;

        font-size: 13px;
        line-height: 16px;

        padding: 4px;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .presentation-preview__item:not(:last-child) {
        margin-bottom: 8px;
    }

    .presentation-preview__info {
        margin: -8px 0;
    }

    .info__column {
        padding: 8px 0;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .presentation-preview__name {
        display: flex;
        color: $hsl-color-blue-56;
        text-decoration: none;
        font-size: 14px;
        line-height: 18px;
        @include media($md) {
            font-size: 16px;
            line-height: 20px;
        }
        @include media($xlg) {
            font-size: 18px;
        }
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .custom-dropdown {
        top: 0;
        left: 0;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }
</style>
